import {
  cleanTwilioCredentialsForMode,
  getTwilioAuthenticateByToken,
  getTwilioVisibleCredentials,
  normalizeTwilioCredentials,
} from '@novu/shared';

export const TWILIO_SENDER_REQUIRED_MESSAGE = 'Provide a Messaging Service SID or From number';

export function getTwilioFormCredentials(credentials: Record<string, unknown>) {
  const authenticateByToken = getTwilioAuthenticateByToken(credentials);

  return {
    authenticateByToken,
    visibleCredentials: getTwilioVisibleCredentials(authenticateByToken),
  };
}

export function prepareTwilioCredentialsForSubmit(credentials: Record<string, unknown>): Record<string, unknown> {
  const cleaned = cleanTwilioCredentialsForMode(credentials);

  try {
    return { ...normalizeTwilioCredentials(cleaned) };
  } catch {
    const hasSender = Boolean(cleaned.messageProfileId || cleaned.from);
    throw new Error(hasSender ? 'Invalid Twilio credentials' : TWILIO_SENDER_REQUIRED_MESSAGE);
  }
}
